import {
  Button,
  FormControlSizes,
  IconButton,
  IconName,
  MixpanelEvent,
  MixpanelEventProperty,
  MixpanelEventSource,
  Popover,
  Stack,
  Toggle,
  useCurrentWindow,
  useMixpanel,
  usePopoverState,
} from '@talos/kyoko';
import { useNavigate } from 'react-router-dom';
import { AdminPaths } from '../NavigationSidebar/hooks/getNavPath';
import { useMarketSelectorContext } from './MarketSelectorContext';
import { MARKET_SELECTOR_POPOUT_WINDOW_NAME } from './tokens';

export const MarketSelectorSettingsButton = () => {
  const mixpanel = useMixpanel();
  const { showDisabledItems, setShowDisabledItems, isNarrow, setAdvancedMode, advancedMode } =
    useMarketSelectorContext();
  const currentWindow = useCurrentWindow();
  const isPopout = currentWindow.name === MARKET_SELECTOR_POPOUT_WINDOW_NAME;
  const navigate = useNavigate();

  const popover = usePopoverState({
    closeOnClickOutside: true,
    trigger: 'click',
    placement: 'bottom-end',
    usePortal: false,
  });

  return (
    <Popover {...popover}>
      <IconButton
        ghost
        icon={IconName.Cog}
        color="colorTextDefault"
        size={FormControlSizes.Small}
        data-testid="market-selector-settings-cog"
      />
      <Stack gap="spacing8">
        <Toggle
          size={FormControlSizes.Small}
          onChange={enabled => {
            setShowDisabledItems(enabled);
            mixpanel.track(MixpanelEvent.ToggleShowDisabled, { [MixpanelEventProperty.Enabled]: enabled });
          }}
          checked={showDisabledItems}
          justifyContent="space-between"
          label="Show disabled items"
          data-testid="market-selector-show-disabled-items-toggle"
        />
        {isNarrow && (
          <>
            {!isPopout && (
              <Toggle
                size={FormControlSizes.Small}
                onChange={enabled => setAdvancedMode(enabled)}
                justifyContent="space-between"
                checked={advancedMode}
                label="Show advanced mode"
                data-testid="market-selector-advanced-mode-toggle"
              />
            )}
            <Button
              startIcon={IconName.Exit}
              size={FormControlSizes.Tiny}
              onClick={() => {
                mixpanel.track(MixpanelEvent.ManageAggregations, {
                  [MixpanelEventProperty.Source]: MixpanelEventSource.MarketAccountSelector,
                });
                navigate(AdminPaths.TradingAggregations());
              }}
            >
              Manage
            </Button>
          </>
        )}
      </Stack>
    </Popover>
  );
};
